/**
 * Collection of basic color codes used throughout the application (names are
 * based on the actual colors used in the original layouts).
 */
export const colors = {
    black: "#313136",
    orange: "#dc4320",
    white: "#fff",
};
